import type { ModuleManifest } from '../types';
import { routes } from './routes';
import { navItems } from './nav';

const investorRelationsModule: ModuleManifest = {
  id: 'P18',
  name: 'Investor Relations',
  shortName: 'IR',
  description: 'Investor portal with cap table, documents, updates, and consent voting',
  icon: 'Landmark',
  status: 'live',
  urlPrefix: '/investors',
  routes,
  navItems,
  collections: {
    INVESTORS: 'investors',
    SHARE_CLASSES: 'shareClasses',
    HOLDINGS: 'holdings',
    INVESTOR_DOCUMENTS: 'investorDocuments',
    INVESTOR_UPDATES: 'investorUpdates',
    CONSENT_REQUESTS: 'consentRequests',
  },
};

export default investorRelationsModule;
